import Model, { attr, belongsTo, hasMany } from '@ember-data/model';
import type { AsyncBelongsTo, AsyncHasMany } from '@ember-data/model';

import type AnnouncementModel from './announcement';
import type AnnouncementRecipientChannelModel from './announcement-recipient-channel';
import type AnnouncementResponseOptionModel from './announcement-response-option';
import type EmployeeModel from './employee';

export enum AnnouncementRecipientResponse {
  Safe = 'safe',
  NeedHelp = 'need_help',
  NoResponse = 'no_response',
}

export default class AnnouncementRecipientModel extends Model {
  @belongsTo('announcement', { async: true, inverse: 'announcementRecipients' })
  declare announcement: AsyncBelongsTo<AnnouncementModel>;
  @belongsTo('employee', { async: true, inverse: null }) declare employee: AsyncBelongsTo<EmployeeModel>;

  @hasMany('announcement-recipient-channel', { async: true, inverse: 'announcementRecipient' })
  declare announcementRecipientChannels: AsyncHasMany<AnnouncementRecipientChannelModel>;

  // will be null if the recipient edited the response
  @belongsTo('employee', { async: true, inverse: null })
  declare lastUpdatedBy: AsyncBelongsTo<EmployeeModel> | null;

  @belongsTo('announcement-response-option', { async: true, inverse: null })
  declare announcementResponseOption: AsyncBelongsTo<AnnouncementResponseOptionModel> | null;

  @attr('string') declare name: string;
  @attr('string') declare phoneNumber?: string;
  @attr('string') declare employeeId: string;
  @attr('string') declare visitorEmail?: string;
  @attr('string') declare status: string;
  @attr('boolean') declare smsSent: boolean;
  @attr('boolean') declare emailSent: boolean;
  @attr('boolean') declare pushSent: boolean;
  @attr('boolean') declare slackSent: boolean;
  @attr('boolean') declare msTeamsSent: boolean;
  @attr('boolean') declare markedAsSafe: boolean;
  @attr('date') declare markedAsSafeAt?: Date;
  @attr('string') declare response?: AnnouncementRecipientResponse;
  @attr('date') declare lastResponseAt?: Date;
  @attr('boolean') declare responseWasEdited: boolean;
}

// DO NOT DELETE: this is how TypeScript knows how to look up your models.
declare module 'ember-data/types/registries/model' {
  export default interface ModelRegistry {
    'announcement-recipient': AnnouncementRecipientModel;
  }
}
